import React from 'react';
import './Spinner.css';
import {connect} from "react-redux";

const spinner = props => (
	<div className='spinner-container'>
		<div className={`lds-ellipsis ${props.currentApp}`}>
			<div />
			<div />
			<div />
			<div />
		</div>
	</div>
);

const mapStateToProps = state => ({
	currentApp: state.appReducer.currentApp
})

export default connect(mapStateToProps)(spinner);